import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface emailTamplateState {
	isLoading: boolean;
	emailTamplateList: any;
	totalemailTamplate: number;
	emailTamplateDetail: any;
}

const initialState: emailTamplateState = {
	isLoading: false,
	emailTamplateList: [],
	totalemailTamplate: 0,
	emailTamplateDetail: {}
};

const emailTamplateSlice = createSlice({
	name: 'EmailSlice',
	initialState,
	reducers: {
		getAllEmailTamplteInit: state => {
			state.isLoading = true;
		},
		getAllEmailTamplteSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalemailTamplate = data.count;
			state.emailTamplateList = [...data.emailTemplates];
		},
		getAllEmailTamplteError: state => {
			state.isLoading = false;
		},
		getEmailTamplteByIdInIt: state => {
			state.isLoading = true;
		},
		getEmailTamplteByIdSuccess: (state, action: PayloadAction<any>) => {
			// console.log(action.payload.data.governmentEmailTampltes);

			state.isLoading = false;
			state.emailTamplateDetail = { ...action.payload.data.emailTemplate };
		},
		getEmailTamplteByIdError: state => {
			state.isLoading = false;
		},
		clearEmailDetail: state => {
			state.emailTamplateDetail = {};
		},
		editEmailDetailInIt: state => {
			state.isLoading = true;
		},
		editEmailDetailSuccess: state => {
			state.isLoading = false;
		},
		editEmailDetailError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAllEmailTamplteError,
	getAllEmailTamplteInit,
	getAllEmailTamplteSuccess,
	getEmailTamplteByIdError,
	getEmailTamplteByIdInIt,
	getEmailTamplteByIdSuccess,
	clearEmailDetail,
	editEmailDetailError,
	editEmailDetailInIt,
	editEmailDetailSuccess
} = emailTamplateSlice.actions;

export default emailTamplateSlice.reducer;
